// src/lib/strapi.ts
import Strapi from "strapi-sdk-js";

const STRAPI_API_URL = process.env.NEXT_PRIVATE_STRAPI_API_URL || ""
const STRAPI_API_TOKEN = process.env.NEXT_PRIVATE_STRAPI_TOKEN || "";

export const strapi = new Strapi({
  url: STRAPI_API_URL,
  store: {
    key: "strapi_jwt",
    useLocalStorage: false,
    cookieOptions: { path: "/" },
  },
  axiosOptions: {
    headers: {
      Authorization: `Bearer ${STRAPI_API_TOKEN}`,
      type: "application/json",
    },
  },
});

// helper function to fetch data image to 3 url format: thumbnail, medium, large form strapi media object
export function getStrapiMedia(media: any) {
  if (!media) return null;
  const { url, formats } = media;

  if (formats) {
    return {
      origin: url,
      thumbnail: formats.thumbnail?.url,
      medium: formats.medium?.url,
      large: formats.large?.url,
    };
  }

  return url;
}

export function getPrice(price: number) {
  return new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
  }).format(price);
}